<template>
  <div>
    <new-identification-notify />
    <idle-worker-disconnect />
    <tab-blink />
  </div>
</template>

<script>
import IdleWorkerDisconnect from "./IdleWorkerDisconnect";
import NewIdentificationNotify from "./NewIdentificationNotify";
import TabBlink from "./TabBlink";
export default {
  components: {
    NewIdentificationNotify,
    IdleWorkerDisconnect,
    TabBlink
  }
};
</script>
